import { useEffect, useMemo, useState, useCallback } from "react";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";
import WhatsAppSticky from "@/components/landing/WhatsAppSticky";
import LeadDialog from "@/components/landing/LeadDialog";
import Reveal from "@/components/landing/Reveal";
import ArticleCard from "@/components/articles/ArticleCard";
import { fetchArticles } from "@/lib/api";

export default function ResourcesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialog, setDialog] = useState({ open: false, type: "meeting" });
  const openMeeting = useCallback(() => setDialog({ open: true, type: "meeting" }), []);
  const openBulk = useCallback(() => setDialog({ open: true, type: "bulk" }), []);
  const closeDialog = useCallback(() => setDialog((d) => ({ ...d, open: false })), []);
  const handlers = useMemo(() => ({ openMeeting, openBulk }), [openMeeting, openBulk]);

  useEffect(() => {
    document.title = "Insights & Resources | Utsah";
    let el = document.querySelector('meta[name="description"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "description");
      document.head.appendChild(el);
    }
    el.setAttribute(
      "content",
      "Practical guides, gifting ideas and workplace insights to help HR, Procurement and People teams create thoughtful gifting experiences."
    );
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetchArticles({ limit: 200 })
      .then((list) => { if (alive) { setItems(list); setLoading(false); } })
      .catch(() => { if (alive) { setItems([]); setLoading(false); } });
    return () => { alive = false; };
  }, []);

  return (
    <div className="utsah-app">
      <Nav onBookMeeting={openMeeting} />

      <section className="section legal-hero" data-testid="resources-hero" style={{ paddingTop: 40 }}>
        <div className="section-inner" style={{ textAlign: "center", maxWidth: 820, margin: "0 auto" }}>
          <Reveal className="eyebrow" style={{ display: "inline-flex", marginLeft: "auto", marginRight: "auto" }}>Insights &amp; Resources</Reveal>
          <Reveal as="h1" delay={1} className="section-headline">
            Ideas that make <em>gifting thoughtful.</em>
          </Reveal>
          <Reveal as="p" delay={2} className="section-sub" style={{ marginTop: 20, marginLeft: "auto", marginRight: "auto" }}>
            Practical guides, gifting ideas and workplace insights to help HR, Procurement and People teams create thoughtful gifting experiences.
          </Reveal>
        </div>
      </section>

      <section className="section resources-list" data-testid="resources-list">
        <div className="section-inner">
          {loading ? (
            <div style={{ textAlign: "center", padding: 60, opacity: 0.6, fontStyle: "italic" }}>Loading…</div>
          ) : items.length === 0 ? (
            <div style={{ textAlign: "center", padding: 60, opacity: 0.6 }} data-testid="resources-empty">
              New articles are coming soon.
            </div>
          ) : (
            <div className="article-grid">
              {items.map((a) => <ArticleCard key={a.id} article={a} />)}
            </div>
          )}
        </div>
      </section>

      <Footer handlers={handlers} />
      <WhatsAppSticky />
      <LeadDialog open={dialog.open} type={dialog.type} source="Resources" onOpenChange={(v) => (v ? null : closeDialog())} />
      <Toaster position="bottom-center" richColors theme="light" />
    </div>
  );
}
